/**
 * Le lien d'un evenement en ligne, tel qu'on le garde, ou `null` s'il ne
 * mene nulle part.
 *
 * On colle souvent un lien sans son debut (« zoom.us/j/123 ») : il est
 * complete. Seuls https et http passent : un `javascript:` pose dans une
 * fiche s'executerait chez qui le touche. La meme porte sert a l'ecriture
 * et a la lecture, parce qu'un client modifie peut ecrire n'importe quoi.
 */
export function normaliserLeLien(brut: string): string | null {
  const texte = brut.trim();
  if (!texte || /\s/.test(texte)) return null;
  const complet = /^[a-z][a-z0-9+.-]*:\/\//i.test(texte) ? texte : `https://${texte}`;
  let url: URL;
  try {
    url = new URL(complet);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  /* « zoom » tout court n'est pas une adresse : il faut un domaine. */
  if (!url.hostname.includes('.')) return null;
  return url.toString();
}

/** Ou l'on se retrouve, en un mot : « zoom.us », « meet.google.com ». */
export function hoteDuLien(lien: string): string {
  try {
    return new URL(lien).hostname.replace(/^www\./, '');
  } catch {
    return lien;
  }
}
